/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    import IDealerwareVehicleFactory = DealerwareWebServices.IDealerwareVehicleFactory;

    export class VehicleDetailsFormDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$state',
            '$mdDialog',
            '$dealerwareVehicleFactory',
            'CurrentUser',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$mobilityCompanyAuthentication',
            'ConvertUnits',
            '$dealerwareInternationalizationData'
        ];

        public vehicle: any;
        private isMetric: boolean;
        public labels: {};

        constructor(public $scope: any,
                    public $state: any,
                    public $mdDialog: any,
                    public $dealerwareVehicleFactory: any,
                    public CurrentUser: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $mobilityCompanyAuthentication: any,
                    public ConvertUnits: any,
                    public $dealerwareInternationalizationData: any) {
            var _self = this;

            this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;

            this.getLabels('vehicles');

            if (!this.vehicle) {
                this.vehicle = this.$dealerwareVehicleFactory.getInstance();
            }
        }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public get trim() : string {
            if (!this.vehicle.vehicleDetails) { return undefined; }

            var vehicle = this.vehicle.vehicleDetails.data;

            this.$scope.colors = [
                "Beige", 
                "Black", 
                "Blue", 
                "Brown", 
                "Gold", 
                "Gray", 
                "Green", 
                "Maroon", 
                "Off-white", 
                "Orange", 
                "Purple", 
                "Red", 
                "Silver", 
                "Tan", 
                "Teal", 
                "White", 
                "Yellow"];

            return `${vehicle.model_year} ${vehicle.make} ${vehicle.model_name}`;
        }

        public saveVehicleDetails() : void {
            var _self = this;
            var loader = this.$dealerwareLoading.show('Saving...');
            this.vehicle.vehicleDetails.$saveVehicleDetails({ promise: true }).then(
                function(response: any) {
                    _self.$scope.vehicleDetailsForm.$setPristine();
                    loader.close();
                    _self.$dealerwareNotification.toast('Vehicle saved!');
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public getConvertedVehicleMileage(): string {
            if (!(
                this.vehicle
                && this.vehicle.vehicleDetails
                && this.vehicle.vehicleDetails.data
            )) {
                return '';
            }
            const mileageInKm = this.vehicle.vehicleDetails.data.mileage_in_km;
            const convertedMileage = this.isMetric
                ? mileageInKm
                : this.ConvertUnits.kmToMiles(mileageInKm);
            return convertedMileage.toFixed();
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleDetailsFormDirectiveController', VehicleDetailsFormDirectiveController);

    export class VehicleDetailsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleDetailsFormDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {vehicle: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/details/vehicle_details_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => { }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleDetails",() => new VehicleDetailsDirective());
}
